import { useCallback, useRef } from "react";
const useStableCallback = (callback) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  const memoizedCallback = useCallback((...args) => {
    return callbackRef.current(...args);
  }, []);
  return memoizedCallback;
};
var useStableCallback_default = useStableCallback;
export {
  useStableCallback_default as default
};
